module.exports = __webpack_public_path__ + "sd.0ac3655be9e6a244270b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sd.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sd.svg
// module chunks = styles